import { IResponse } from '../../types/types';
import { AlertType } from "../../types/enums";
import { showAlert } from '../Alerts/alerts.actions';

import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Icon,
    Modal,
    Theme
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
//import { deleteSubmissionAction, clearDeleteSubmissionAction } from './claimFile.actions';

const createLocalStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            position: 'absolute',
        },
        claimmodal: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            justifyContent: 'center',
            width: '700px;'
        },
        modalHeader: {
            backgroundColor: theme.palette.primary.main,
            minWidth: 500,
            color: theme.palette.common.white,
            textEmphasisColor: theme.palette.common.white,
            font: '16',
        },
        modalHeaderTitle: {
            paddingBottom: '5px;'
        },
        title: {
            flexGrow: 1,
            color: 'black',
            marginBottom: '10px'
        },
        cardAction: {
            justifyContent: 'flex-end'
        },
        primaryBtn: {
            color: '#fff!important',
            backgroundColor: 'red!important'
        },
        secondaryBtn: {
            color: 'blue',
            backgroundColor: '#fff!important',
            border: '1px solid',
            borderColor: 'blue'
        },
        paragraph: {
            marginBottom: '-5px'
        },
        icon: {
            color: 'red',
            fontSize: '30px',
            marginBottom: '-5px'
        },
    }),
);


interface IDeleteTemplateModalProps {
    modalOpen: boolean,
    handleCancelClose: any,
    handleDelete: any,
    templateId: number | null,
    templateName: string
}

const DeleteTemplateModal = ({ modalOpen, handleCancelClose, handleDelete, templateId, templateName
}: IDeleteTemplateModalProps) => {

    const classes = createLocalStyles();
    
    return (
        <Modal
            open={modalOpen}
            onClose={() => {
                handleCancelClose();
            }}>
            <Card className={classes.claimmodal}>
                <CardHeader
                    title={<span className="material-symbols-outlined"><Icon className={classes.icon}>warning</Icon>Delete Template</span>}
                    classes={{ title: classes.modalHeaderTitle }}
                    action={<Icon onClick={() => {
                        handleCancelClose();
                    }}>close</Icon>}>
                </CardHeader>
                <CardContent>
                    <Typography variant="h6" className={classes.title} noWrap>
                        Are you sure you want to delete this template?
                    </Typography>
                    <Typography variant="body1" className={classes.title} noWrap>
                        {templateName}
                    </Typography>
                    <br />
                    <Typography variant="body1" className={classes.title} noWrap>
                        This action cannot be undone.
                    </Typography>
                </CardContent>
                <CardActions className={classes.cardAction}>
                    <Button
                        classes={{ root: classes.primaryBtn, disabled: classes.primaryBtn }}
                        onClick={() => {
                            handleDelete(templateId);
                        }}
                        color="primary" >
                        Delete
                    </Button>
                    <Button
                        onClick={() => {
                            handleCancelClose()
                        }}
                        classes={{ root: classes.secondaryBtn, disabled: classes.secondaryBtn }}
                        color="secondary">
                        Cancel
                    </Button>
                </CardActions>
            </Card >
        </Modal >
    );
};

export default DeleteTemplateModal;